import {THEME} from "../../../app/consts";
import {AssetsRequestParams} from "../../../../infrastructure/models/params/assets-request-params";

export class PenaltiesGoalRequestParams extends AssetsRequestParams {
  constructor({width, height}) {
    super({width, height});

    this.resourceName = `${this.resourceName}/Goalmounth`;
    this.version = 18;
  }

  get pathPostfix(): String {
    return super.pathPostfix + (this.theme === THEME.DARK ? `_dark` : '_light');
  }
}